<template>
  <v-dialog v-model="show" persistent max-width="800">
    <v-card>
      <v-card-title>Add mash note</v-card-title>
      <v-divider/>
      <v-card-text class="pb-0 px-0 pt-2">
        <v-form ref="form" v-model="valid">
          <v-container class="pt-4 px-4">
          <v-row>
            <v-col cols="8" md="4">
              <date-picker v-model="note.date" label="Date"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea label="Comments" rows="4"
                           v-model="note.comments" outlined dense :rules="[fieldRules.required,fieldRules.maxLength(500)]" counter="500"/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" md="3">
              <v-checkbox label="Add item to mash" v-model="addItem"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <multi-level-select v-if="categories.length" :menuData="eligibleItems" :second.sync="note.itemId" :disabled="!addItem" outlined @change="changeItem()"/>
              <v-autocomplete v-else :items="items" item-text="name" item-value="id" v-model="note.itemId" dense @change="changeItem()" class="text-body-2"/>
            </v-col>
            <v-col cols="6" md="3">
              <v-combobox :disabled="!item.lotTracking || !addItem" label="Lot" :items="currentLots" v-model="note.itemLot" :rules="addItem ? [lotRequired,fieldRules.maxLength(20)]: []" dense
                          @change="changeItemLot()" outlined/>
            </v-col>
            <v-col cols="6" md="3">
              <decimal-number-input label="Quantity" v-model="note.itemQuantity" prefix="" :disabled="!addItem"
                    :suffix="item.trackUnits" :precision="item.precision"/>
            </v-col>
          </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer/>
        <v-btn plain color="primary" @click="$emit('input', false)">Cancel</v-btn>
        <v-btn color="primary" @click="save()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {format} from 'date-fns'
import createHierarchyList from '@/mixins/createHierarchyList'

export default {
  name: 'ProductionMashingNotesAdd',
  mixins: [createHierarchyList],
  props: {
    value: {type:Boolean, required:true},
    mash: {type:Object, required:false},
    hasNotes: {type:Boolean, required:false}
  },
  data () {
    return {
      show: false,
      loading: false,
      valid: true,
      note: {},
      addItem: false,
      categories: [],
      items: [],
      lotRequired: v => !!v || !this.addItem || 'Required'
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    item() {
      return this.items.find(item => item.id === this.note.itemId) || {};
    },
    currentLots() {
      return this.item.sites ? this.item.sites.filter(site => site.siteId === this.mash.site.id).map(site => site.lot) : [];
    },
    eligibleItems() {
      const categories = this.createHierarchyList(this.categories);
      for (const category of categories) {
        const sub = this.items.filter(item => item.category?.id === category.id);
        if (sub.length)
          category.menu = sub;
        else
          category.disabled = true;
      }
//      const items = [...categories.filter(category => !category.disabled)];
      const items = categories;
      const leftOver = this.items.filter(item => !item.category?.id);
      if (leftOver.length)
        items.push({divider:true},{name:'Other items',id:'x',menu:leftOver});
      return items;
    }
  },
  watch: {
    async value() {
      this.show = this.value;
      this.addItem = false;
      this.note = {date:format(new Date(),'yyyy-MM-dd HH:mm:ss'), comments:'',itemId:null,itemQuantity:0,itemLot:''}
    }
  },
  async created() {
    this.addItem = false;
    this.note = {date:format(new Date(),'yyyy-MM-dd HH:mm:ss'), comments:'',itemId:null, itemQuantity:0, itemLot:''}
    this.$lazyListLoad(this.categories, 'categories2', 'id,name,parent{id}', 100, [], [{name:'type',value:'Item'}]);
    this.$lazyListLoad(this.items, 'items2', 'id,name,lotTracking,trackUnits,precision,category{id}', 100, [{field:'active', comparator:'eq', value:'true'}]);
  },
  methods: {
    async changeItem() {
      if (this.item && !this.item.sites) {
        const results = await this.$apiCall(`query ProductionMashingNotesAdd($id:ID!, $date:DateTime!) {
                                                  item(id:$id) {
                                                    sites(asof:$date) {siteId,lot,quantity}
                                                  }
                                                }`,
                                            {id:this.item.id,date:this.note.date});
        if (!results.error)
          this.$set(this.item, 'sites', results.data.item.sites);
      }

      this.$refs.form.validate();
    },
    changeItemLot() {

    },
    async save() {
      if (!this.valid) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }
      this.loading = true;
      const input = {...this.note, mashId:this.mash.id, itemId:this.addItem?this.note.itemId:null};
      const results = await this.$apiCall(`mutation ProductionMashingNotesAdd($input:MashNoteInput!) {
                                                mashNoteAdd(input:$input) {
                                                  id,date,comments,itemName,itemUnits,itemQuantity,itemPrecision
                                                }
                                              }`,
                                          {input});
      this.loading = false;
      if (!results.error) {
        this.$emit('noteAdded', results.data.mashNoteAdd);
        this.$emit('input', false);
      }
    }
  }
}
</script>